export enum PasswordProvider {
    IAM = 'IAM'
}
